import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconLikeSolidComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-LikeSolid${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M33.212 9c-3.869 0-7.277 1.867-9.212 4.8-1.935-2.933-5.343-4.8-9.212-4.8-6.08 0-11.055 4.8-11.055 10.667C3.733 30.244 24 41 24 41s20.267-10.667 20.267-21.333C44.267 13.8 39.292 9 33.212 9z" fill={useCurrentColor ? 'currentColor' : '#69718C'}/></svg>;
}

const IconLikeSolid = React.forwardRef(IconLikeSolidComponent);
export default IconLikeSolid;
